<template>
  <div class="movie">
    <header-box :title="title"></header-box>
    <div class="movie__innerwrap">
      <div class="movie__video-wrapper">
        <movie-player :movieUrl="coverVideo" :placeholderUrl="coverVideoPlaceholder"></movie-player>
      </div>
      <div class="movie__blocks">
        <div class="movie__block" v-for="block in contentBlocks">

          <div class="movie__block-image" v-if="(block.imagePosition === 'left')">
            <movie-player v-if="block.video" class="movie__block-video" :movieUrl="block.video" :placeholderUrl="block.image" autoplay="true"></movie-player>
            <img v-if="!block.video" :src="block.image" />
          </div>

          <div class="movie__block-textwrap">
            <h2 class="movie__block-title" v-html="block.title"></h2>
            <div class="movie__block-content" v-html="block.content"></div>
          </div>

          <div class="movie__block-image" v-if="(block.imagePosition === 'right')">
            <movie-player v-if="block.video" class="movie__block-video" :movieUrl="block.video" :placeholderUrl="block.image" autoplay="true"></movie-player>
            <img v-if="!block.video" :src="block.image" />
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PrevNextNav from '@/components/PrevNextNav';
import HeaderBox from '@/components/HeaderBox';
import MoviePlayer from '@/components/MoviePlayer';

export default {
  name: 'movie',
  components: { PrevNextNav, HeaderBox, MoviePlayer },
  computed: {
    ...mapGetters(['page']),
    title() {
      return this.page.title;
    },
    coverVideo() {
      return this.page.coverVideo;
    },
    coverVideoPlaceholder() {
      return this.page.coverVideoPlaceholder;
    },
    contentBlocks() {
      return this.page.contentBlocks;
    },
  },
  mounted() {
    const vids = document.querySelectorAll('.movie__block-video');

    [].forEach.call(vids, (vid) => {
      vid.addEventListener('ended', () => {
        vid.classList.add('hide');
      });
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../scss/helpers';

.movie {
  @include page;

  &__innerwrap {
    padding-top: 0;
  }

  &__video-wrapper {
    display: block;
    width: 100%;
    position: relative;
    z-index: 1;
    margin: 0 0 20px;

    @include not-mobile {
      width: calc(91.6666% - 10px);
      margin: 0 0 40px calc(8.3333% + 10px);
    }

    @include landscape {
      width: calc(75% - 10px);
      margin: 0 0 20px calc(25% + 10px);
    }

    @include not-tablet {
      width: 83.3333%;
      margin: 0 0 40px 16.6666%;
    }

    @include desktop {
      width: 75%;
      margin: 0 8.3333% 40px 16.6666%;
    }
  }

  &__blocks {
    box-sizing: border-box;
    // padding: 40px;
  }

  &__block {
    box-sizing: border-box;
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;

    @include not-mobile {
      flex-direction: row;
      padding-bottom: 40px;
    }

    @include tablet {
      display: block;
    }

    @include landscape {
      display: flex;
      flex-direction: row;
      padding-bottom: 20px;
    }
  }

  &__block-image {
    display: block;
    position: relative;
    overflow: hidden;

    @include tablet {
      width: calc(66.66% - 10px);
    }

    @include landscape {
      width: 50%;
    }

    @include not-tablet {
      width: 50%;
    }

    img {
      display: block;
      width: 100%;
    }

    // video + img {
    //   transition: opacity .5s;
    // }

    // video:not(.hide) + img {
    //   opacity: 0;
    // }
  }

  &__block-video {
    // width: 100%;
    // display: block;
    // position: absolute;
    // top: 0;
    // left: 0;
    // right: 0;
    // transition: opacity .5s;

    // &.hide {
    //   opacity: 0;
    //   pointer-events: none;
    // }
  }

  &__block-textwrap + &__block-image {
    @include tablet {
      margin-left: calc(33.33% + 10px);
    }

    @include landscape {
      margin: 0;
    }
  }

  &__block-textwrap {
    box-sizing: border-box;
    background: $c_white;
    padding: 35px 30px;

    @include mobile {
      order: 1;
    }

    @include tablet {
      width: calc(66.66% - 10px);
      margin-bottom: -40px;
      padding: 40px 40px 80px;
    }

    @include landscape {
      order: unset;
      width: 50%;
      padding: 35px 30px;
      margin: 0;
    }

    @include not-tablet {
      width: 50%;
      padding: 40px;
    }

    @include desktop {
      width: 33.33%;
      margin-left: 16.665%;
    }
  }

  &__block-image + &__block-textwrap {
    @include tablet {
      margin-left: calc(33.33% + 10px);
      margin-top: -40px;
      margin-bottom: 0;
      padding: 80px 40px 40px;
    }

    @include landscape {
      margin: 0;
      padding: 35px 30px;
    }

    @include not-tablet {
      margin-left: 0;
    }
  }

  &__block-title {
    @include font-block-title;
  }

  &__block-content {
    @include font-block-content;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/templates/Movie.vue